import { SEO } from "@/components/SEO";
import React from "react";
import { Link } from "react-router-dom";
import { CheckCircle2 } from "lucide-react";

const pasos = [
  { n: "1", t: "Elige tu experiencia", d: "Mira el catálogo de este mes. Cada experiencia pertenece a un área —Tertulia, Letras y Lenguas, Tercera Llamada, Experiencias en familia, Vivir Pleno o Futuro Seguro— y tiene un formato: charla, clase, salida o taller." },
  { n: "2", t: "Anota tus datos", d: "Solo necesitamos tu nombre, tu correo y tu teléfono. Nada más." },
  { n: "3", t: "Paga en línea", d: "Con tarjeta de crédito o débito, de forma segura." },
  { n: "4", t: "Listo", d: "Te llegará un correo con todo lo que necesitas: la fecha, la hora, y cómo conectarte." },
];

export default function ComoFunciona() {
  return (
    <div className="max-w-4xl mx-auto px-6 py-20 lg:py-16 md:py-24">
      <SEO title="Cómo funciona · Utopistas" description="Cuatro pasos muy sencillos para participar en las experiencias de Utopistas, la comunidad de Dra. Cometa para adultos mayores." />
      <p className="text-base tracking-[0.3em] text-cometa-marino/70 mb-3">CÓMO FUNCIONA</p>
      <h1 className="text-4xl sm:text-5xl md:text-7xl leading-[0.95] mb-8">Cuatro pasos. <em className="text-cometa-carmesi">Muy sencillo.</em></h1>

      <div className="space-y-6 mb-16">
        {pasos.map((p) => (
          <div key={p.n} className="flex gap-6 bg-white border border-cometa-marino/10 rounded-2xl p-6 lg:p-8">
            <div className="text-6xl font-display text-cometa-dorado w-20 shrink-0">{p.n}</div>
            <div>
              <h3 className="text-2xl mb-2">{p.t}</h3>
              <p className="text-lg text-cometa-tinta/80 leading-relaxed">{p.d}</p>
            </div>
          </div>
        ))}
      </div>

      <div className="bg-cometa-marino text-cometa-crema rounded-3xl p-10 text-center">
        <p className="font-script text-3xl text-cometa-dorado mb-3">¿Tienes dudas?</p>
        <p className="text-xl mb-6">Escríbenos y con gusto te ayudamos.</p>
        <Link to="/contacto" data-testid="cf-contacto" className="btn inline-flex items-center gap-2 bg-cometa-dorado text-cometa-tinta px-8 py-4 rounded-full font-semibold text-lg hover:bg-cometa-carmesi hover:text-white transition">
          Escribir a Cometa
        </Link>
      </div>

      <div className="mt-12 flex items-center gap-3 text-cometa-tinta/60">
        <CheckCircle2 size={20} className="text-cometa-marino" />
        <p>Un solo perfil para todas tus experiencias. No te pediremos tus datos dos veces.</p>
      </div>
    </div>
  );
}
